import { render } from "./StudentNavbar.vue?vue&type=template&id=8f37c3ac"
import script from "./StudentNavbar.vue?vue&type=script&lang=js"
export * from "./StudentNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__